import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const RefreshArrowIcon = (props) => (
    <SvgIcon viewBox="0 0 14 14" sx={{ height: '14px', width: 'auto', ...props }}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 0V1.55555C10.0014 1.55555 12.4444 3.99778 12.4444 7C12.4444 10.0022 10.0014 12.4444 7 12.4444C3.99855 12.4444 1.55555 10.0022 1.55555 7C1.55555 5.56345 2.12722 4.21089 3.11111 3.20289L3.11111 5.05555H4.66667L4.66667 0.77778L0.388886 0.77778L0.388886 2.33333L1.78189 2.33333C0.646333 3.60267 0 5.257 0 7C0 10.8593 3.13989 14 7 14C10.8601 14 14 10.8593 14 7C14 3.14067 10.8601 0 7 0Z"
                fill="#8F8F8F"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </SvgIcon>
);

export default RefreshArrowIcon;